import { Question } from '../../../../datasources/questions/QuestionsDataSource';
import { Basket } from '../../../../types/basket/Basket';
import { FlowDefinition, FlowType } from '../../../../types/flow/Flow';
import {
  BasketQuestionDTO,
  BasketQuestionOptionDTO,
  BasketResponseDTO,
  ConditionRule,
  VisibilityConditionDTO,
} from '../../../orders/pages/newOrderFlow/configureEquipmentMockup/types';


export function buildPreviewQuestionnaire(
  definition: FlowDefinition,
  questions: Question[],
  baskets: Basket[],
  code: string,
  type: FlowType
): BasketResponseDTO {
  const questionsByCode = new Map(
    questions
      .filter((question) => question.active)
      .map((question) => [question.code, question])
  );
  const basketsById = new Map(baskets.map((basket) => [basket.id, basket]));
  const questionNodes = definition.nodes.filter((node) => node.type === 'QUESTION');
  const result: BasketQuestionDTO[] = [];

  questionNodes.forEach((node, index) => {
    const question = questionsByCode.get(node.question);
    if (!question) return;

    const incomingEdges = definition.edges.filter(
      (edge) => edge.to === node.id && edge.when
    );
    const groups: { all: ConditionRule[] }[] = incomingEdges.flatMap((edge) =>
      edge.when?.any
        ? edge.when.any.map((rule) => ({ all: [rule as ConditionRule] }))
        : [{ all: (edge.when?.all ?? []) as ConditionRule[] }]
    );
    const visibility: VisibilityConditionDTO | undefined =
      groups.length === 0
        ? undefined
        : groups.length === 1
        ? groups[0]
        : { any: groups };

    const options: BasketQuestionOptionDTO[] = question.options
      .slice()
      .sort((first, second) => first.sort_order - second.sort_order)
      .map((option) => {
        const basket =
          option.basket_id != null ? basketsById.get(option.basket_id) : undefined;
        return {
          value: option.value,
          label: option.label,
          action: basket
            ? {
                type: 'SHOW_BASKET' as const,
                basket: {
                  code: basket.code,
                  name: basket.name,
                  allow_model_selector: Boolean(basket.allow_model_selector),
                  products: (basket.basket_items ?? [])
                    .filter((item) => item.product)
                    .map((item) => ({
                      id: item.product.id,
                      description: item.product.description,
                      sap_code: item.product.sap_code,
                    })),
                },
              }
            : null,
        };
      });

    result.push({
      code: question.code,
      text: question.text,
      type: question.type as BasketQuestionDTO['type'],
      required: question.required,
      sortOrder: index + 1,
      visibility,
      options,
    });
  });

  return {
    product: { id: 0 },
    flow: { code, type },
    questions: result,
  };
}
